import { CatalogAddModal, CatalogAddModalProps } from "features/shared/components/technical-config-tab/CatalogAddModal";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import type { RoomCatalogFormState, RoomTypeCatalogItem } from "../model/types";

import { useCreateCatalogItem } from "../api/hooks";
import { buildRoomCatalogFormConfig } from "../lib/roomConfigDrawerFields";
import { defaultCatalogFormState, mapCatalogFormStateToPayload } from "../lib/roomConfigForm";

export const RoomCatalogAddModal = ({
  catalog,
  onClose,
  open,
}: {
  catalog: readonly RoomTypeCatalogItem[];
  onClose: () => void;
  open: boolean;
}) => {
  const { t } = useTranslation();
  const { isLoading: isSubmitting, mutate: createCatalogItem } = useCreateCatalogItem();
  const buildConfig: CatalogAddModalProps<RoomCatalogFormState>["buildConfig"] = useCallback(
    (params) => buildRoomCatalogFormConfig({ ...params, catalog }),
    [catalog]
  );

  const handleSubmit = (formState: RoomCatalogFormState) => {
    if (!formState.roomTypeName.trim()) {
      toast.error(String(t("TechnicalData.room.roomTypeNameRequired")));
      return;
    }
    createCatalogItem({ data: mapCatalogFormStateToPayload(formState) }, { onSuccess: onClose });
  };

  return (
    <CatalogAddModal
      buildConfig={buildConfig}
      createInitialState={defaultCatalogFormState}
      headerColumns={2}
      height="100vh"
      isSubmitting={isSubmitting}
      onClose={onClose}
      onSubmit={handleSubmit}
      open={open}
      title={String(t("TechnicalData.room.addCatalogTitle"))}
      width="70rem"
    />
  );
};
